import React, { useEffect, useState } from "react";
import ConcertCard from "../../shared/concertCard/ConcertCard";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SkellitonCard from "../../shared/skellitonCard/SkellitonCard";

const ConcertCardList = ({ setIsVisible, category }) => {
  const [cards, setCards] = useState([]);
  const [userLogin, setUserLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("@user");

  useEffect(() => {
    const fetchCards = async () => {
      setLoading(true);
      try {
        const params = {
          access_token: accessToken,
          limit: 5,
        };

        if (category > 0) {
          params.category = category;
        }

        const response = await axios.get(
          `https://htprdapi.hightable.ai/tables/list-public?limit=5`,
          { params }
        );
        setTimeout(() => {
          setLoading(false);
          setCards(response.data.items);
        }, 1500);
      } catch (error) {
        console.error("Error fetching concert cards:", error);
        try {
          const params = {
            access_token: accessToken,
            limit: 5,
          };

          if (category > 0) {
            params.category = category;
          }

          const response = await axios.get(
            `https://htprdapi.hightable.ai/tables/lsist-public?limit=5`,
            { params }
          );
          setTimeout(() => {
            setLoading(false);
            setCards(response.data.items);
          }, 1500);
          setUserLogin(false);
        } catch (publicError) {
          console.error("Error fetching public concert cards:", publicError);
          setLoading(false);
        }
      }
    };

    fetchCards();
  }, [category]);

  const accesstoken = localStorage.getItem("@user");

  // useEffect(() => {
  //   const accesstoken = localStorage.getItem("@user");
  //   if (accesstoken !== null) {
  //     setUserLogin(true);
  //   }
  // }, []);

  const handleNavigate = (name, id) => {
    navigate(`/details?table=${name}&id=${id}`);
  };

  return (
    <div
      data-w-tab="Tab 1"
      className="tab-content-item w-tab-pane w--tab-active"
    >
      {cards.length <= 0 && loading && (
        <>
          <div className="tab-content">
            <div className="w-layout-grid table-category-grid ">
              <SkellitonCard />
              <SkellitonCard />
              <SkellitonCard />
              <SkellitonCard />
              <SkellitonCard />
              <SkellitonCard />
              <SkellitonCard />
              <SkellitonCard />
            </div>
          </div>
        </>
      )}

      <div className="tab-content">
        {accesstoken !== null ? (
          <div className="w-layout-grid table-category-grid ">
            {cards.map((card, index) => (
              <div
                key={index}
                onClick={() => handleNavigate(card?.title, card.id)}
              >
                <ConcertCard slide={card} />
              </div>
            ))}
          </div>
        ) : (
          <div className="w-layout-grid table-category-grid  ">
            {cards.map((card, index) => (
              <div key={index} onClick={() => setIsVisible(true)}>
                <ConcertCard slide={card} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConcertCardList;
